export const config = {
  googleSiteVerification: 'ekRLBeboUMVHXAXiY4bxqugflTQXeHP4fmHVohFb-v4',
  reCaptchaSiteKey: '6Ld_b-QpAAAAAExzl2YIgMxntE4Wfu8Yhz5-cLOP',
  baseUrl: 'https://www.designstudiouiux.com',
  wp_url: process.env.WP_URL || 'https://www.designstudiouiux.com',
}
